export default "__VITE_ASSET__CSGhFZ3f__"